import ctl from "@netlify/classnames-template-literals";

export const searchBarWrapper = ctl(`
  relative
  flex
  items-center
  justify-between
  border
  border-neutral-200
  align-middle
  rounded-2xl
  bg-neutral-50
  py-2
  pl-3
  pr-10
  focus-within:border-neutral-600
  focus-within:bg-white
  transition-all
  duration-200
`);

export const searchBarWrapperDark = ctl(`
  relative
  flex
  items-center
  justify-between
  border
  !border-transparent
  align-middle
  rounded-2xl
  !bg-neutral-800
  py-2
  pl-3
  pr-10
  focus-within:border-white
  transition-all
  duration-200
`);

export const searchInputBar = ctl(`
  bg-transparent
  w-full
  px-2
  py-1
  text-base
  border-none
  outline-none
  placeholder:text-neutral-500
  text-neutral-900
  caret-purple-900
  focus:placeholder-transparent
`);

export const searchInputBarDark = ctl(`
  bg-transparent
  w-full
  px-2
  py-1
  text-base
  border-none
  outline-none
  placeholder:text-neutral-400
  text-white
  caret-green-500
  focus:placeholder-transparent
  focus:ring-0
`);

export const searchCloseButton = ctl(`
  absolute
  right-0
  top-0
  mt-3
  mr-3
`);
